module.exports = __webpack_public_path__ + "static/media/Homemain.f9cf63bc.webp";